<div class="loading-container" *ngIf="loadSpinner">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
</div>
<!-- Edit View -->
<ng-container *ngIf="canEdit">
    <div>This case is out of compliance. Please select the reason(s) for the delay. *</div>
    <div class="enter-rfd-container">
        <kendo-dropdownlist [data]="availableReasons" textField="extDescr" valueField="id" [(ngModel)]="reasonForDelay">
        </kendo-dropdownlist>

        <button kendoButton [fillMode]="'solid'" [themeColor]="'primary'" (click)="addReasonForDelay()"
            [disabled]="!reasonForDelay">Add
        </button>
    </div>

    <div *ngIf="form">
        <form class="k-form k-form-md k-w-full" [formGroup]="form">
            <div formArrayName="reasons" class="list-of-reasons-container"
                [class.selected-reasons-panel]="hasActiveReasons">
                <div *ngFor="let reason of reasonsControls; let i = index;" [formGroupName]="i" class="k-w-full">
                    <ng-container *ngIf="reason.get('isActive')?.value">
                        <kendo-expansionpanel [title]="reason.get('reasonForDelay')?.value?.extDescr"
                            [expanded]="reason.get('expanded')?.value">
                            <div class="rfd-content">
                                <div class="date-added-by">
                                    <div>
                                        <span class="small-text-secondary">Date Added</span>
                                        <div>{{ reason.get('dateAdded')?.value |date : "MM/dd/yyyy"}}</div>
                                    </div>

                                    <div>
                                        <span class="small-text-secondary">Added By</span>
                                        <div>{{ reason.get('addedBy')?.value }}</div>
                                    </div>
                                </div>

                                <div>
                                    <span class="small-text-secondary">Reason for Delay</span>
                                    <div>{{ reason.get('reasonForDelay')?.value?.extDescr }}</div>
                                </div>

                                <kendo-formfield>
                                    <kendo-label text="Description " [for]="description">
                                    </kendo-label>
                                    <kendo-textarea [fillMode]="'outline'" formControlName="description" #description
                                        placeholder="Type Here" [rows]="3" resizable="vertical">
                                    </kendo-textarea>
                                </kendo-formfield>

                                <kendo-formfield>
                                    <kendo-fileselect appFileRestrictions class="fileselect-wrapper__select"
                                        formControlName="files" [showFileList]="true" [multiple]="true">
                                    </kendo-fileselect>
                                    <app-documents [documents]="reason.get('existingDocuments')?.value"
                                        [editMode]="true" (ondeleteDocument)="onDeleteDocument($event, reason)">
                                    </app-documents>
                                </kendo-formfield>

                                <span kendoTooltip position="bottom"
                                    [title]="activeReasonsCount <= 1 ? 'Cannot remove. Minimum one reason is required for this case.' : ''">
                                    <button kendoButton [fillMode]="'outline'" [themeColor]="'error'"
                                        (click)="onRemoveClick(i)" [disabled]="activeReasonsCount <= 1">
                                        Remove
                                    </button>
                                </span>
                            </div>

                        </kendo-expansionpanel>
                    </ng-container>

                </div>
            </div>
        </form>
    </div>
</ng-container>

<!-- Non-edit View -->
<ng-container *ngIf="!canEdit">
    <div *ngIf="form">
        <form class="k-form k-form-md k-w-full" [formGroup]="form">
            <div formArrayName="reasons" class="list-of-reasons-container">
                <div *ngFor="let reason of reasonsControls; let i = index;" [formGroupName]="i" class="k-w-full">
                    <kendo-expansionpanel [title]="reason.get('reasonForDelay')?.value?.extDescr"
                        [expanded]="reasonsControls.length === 1">
                        <div class="rfd-content">
                            <div class="date-added-by">
                                <div>
                                    <span class="small-text-secondary">Date Added</span>
                                    <div>{{ reason.get('dateAdded')?.value |date : "MM/dd/yyyy"}}</div>
                                </div>

                                <div>
                                    <span class="small-text-secondary">Added By</span>
                                    <div>{{ reason.get('addedBy')?.value }}</div>
                                </div>
                            </div>


                            <div>
                                <span class="small-text-secondary">Reason for Delay</span>
                                <div>{{ reason.get('reasonForDelay')?.value?.extDescr }}</div>
                            </div>


                            <div>
                                <span class="small-text-secondary">Description</span>
                                <div>{{ reason.get('description')?.value || '--' }}</div>
                            </div>

                            <div *ngIf="reason.get('existingDocuments')?.value?.length">
                                <app-documents [documents]="reason.get('existingDocuments')?.value" [editMode]="false">
                                </app-documents>
                            </div>
                        </div>
                    </kendo-expansionpanel>
                </div>
            </div>
        </form>
    </div>
</ng-container>

<kendo-dialog *ngIf="removeConfirmDialogOpen" title="Remove Reason" (close)="cancelRemove()"
    id="remove-reason-for-delay" [width]="400" (click)="$event.stopPropagation()">
    <div>Are you sure you want to remove this reason?</div>
    <kendo-dialog-actions>
        <button kendoButton [fillMode]="'outline'" [themeColor]="'error'" (click)="cancelRemove()">No, Go
            Back</button>
        <button kendoButton [fillMode]="'solid'" [themeColor]="'error'" (click)="confirmRemove()">Yes,
            Confirm</button>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="closeConfirmDialogOpen" title="Warning" (close)="cancelClose()" [width]="400"
    (click)="$event.stopPropagation()" id="close-reason-for-delay">
    <div>Are you sure you want to close this popup? Any information added will not be saved.</div>
    <kendo-dialog-actions>
        <button kendoButton [fillMode]="'outline'" [themeColor]="'error'" (click)="confirmClose()">Confirm and
            Exit</button>
        <button kendoButton [fillMode]="'solid'" [themeColor]="'primary'" (click)="cancelClose()">Go
            Back</button>
    </kendo-dialog-actions>
</kendo-dialog>